import {
    loadSkillList,
    insertSkill,
    updateSkill,
    updateActive,
    deleteSkill,
    getSkillListBin,
} from "@/service/skill/skill";
export default {
    data() {
        return {
            status_toggle: 0,
            isOpen: false,
            skillName: "",
            skillID: "",

            headerDialog: false,
            footerDialog: false,
            buttonDialog: false,
            overallDialog: false,

            filterdialog: false,
            deleteDialog: false,
            loading: true,
            sortType: ["เวลา สูง-ต่ำ", "เวลา ต่ำ-สูง", "ยอดนิยม สูง-ต่ำ", "ยอดนิยม ต่ำ-สูง"],

            searchdata: "",
            sortData: "",
            searchSkill: null,
            pageCount: 1,
            limit: 10,
            valid: true,
            skill: [],
            selectedSkill: [],
            params: {},
            deleteItemID: [],

            editSkill: null,
            resultSkill: null,

            actionEdit: "",

            dialogStatus: false,
            dialogStatusActive: false,
            dialogSuccess: false,
            dialogUsernameDuplicade: false,
            dialogAddFail: false,
            dialogAddSuccess: false,
            dialogEditSuccess: false,

            dialogRecycleBin: false,
            dialogRecover: false,
            loadingRecover: false,
            skillBinItem: [],
            dialogFail: false,
            skillListBin: [],
            pageCountBin: 0,
            paramsBin: {},

            alert: false,
        };
    },
    async mounted() {
        await this.initialize();
    },
    computed: {
        // pages() {
        //   if (
        //     this.pagination.rowsPerPage == null ||
        //     this.pagination.totalItems == null
        //   )
        //     return 0;
        //   return Math.ceil(
        //     this.pagination.totalItems / this.pagination.rowsPerPage
        //   );
        // }

        skillNameRules() {
            return [
                (v) => !!v || this.$vuetify.lang.t("$vuetify.skillManagement.skillNameRules"),
                (v) =>
                    (v && v.length <= 50) ||
                    this.$vuetify.lang.t("$vuetify.skillManagement.skillNameRulesLimit"),
            ];
        },
        headersBin() {
            return [
                {
                    text: this.$vuetify.lang.t("$vuetify.skillManagement.name"),
                    sortable: false,
                    align: "start",
                    value: "title",
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.skillManagement.recover"),
                    align: "center",
                    sortable: false,
                    value: "edit",
                },
            ];
        },
        headers() {
            return [
                {
                    text: this.$vuetify.lang.t("$vuetify.skillManagement.name"),
                    value: "title",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.skillManagement.createdDate"),
                    align: "center",
                    value: "date",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.skillManagement.statusHeader"),
                    value: "active",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.skillManagement.editSkill"),
                    align: "center",
                    value: "actions",
                    sortable: false,
                },
            ];
        },
    },
    watch: {
        searchdata(keyword) {
            this.searchInfo(keyword);
        },
        params: function (newValue) {
            console.log(newValue);
        },
    },
    methods: {
        async initialize() {
            this.params = {
                search: this.searchSkill,
                sort: "created_at",
                sortby: -1,
                page: 1,
                limit: 10,
                active: "null",
            };
            this.searchdata = "";
            this.status_toggle = 0;
            if (!this.$store.state.permission.viewCategory) {
                this.noPermission();
            } else {
                await this.getSkillList();
            }
            // console.log("this.skill");
        },
        async changePage(page) {
            this.params.page = page;
            await this.getSkillList();
        },
        refreshFilter() {
            this.initialize();
        },
        async onUpload() {
            let isValidForm = true;

            if (this.skillName.length > 2 && this.skillName.length <= 50) {
                isValidForm = true;
            } else {
                isValidForm = false;
            }

            if (isValidForm) {
                await this.insertSkill();
                await this.getSkillList();
            }
        },
        searchInfo(keyword) {
            this.params.search = keyword;
            this.getSkillList();
        },
        async getSkillList() {
            this.loading = true;
            let result = await loadSkillList(this.params);
            this.skill = [];
            this.pageCount = result.maxPage;
            result.data.forEach((resultSkill) => {
                this.skill.push({
                    // ...resultSkill,
                    date: resultSkill.created_at,
                    id: resultSkill._id,
                    title: resultSkill.title,
                    active: resultSkill.active,
                });
            });
            this.loading = false;
            console.log(this.skill);
        },
        noPermission() {
            this.alert = true;
        },

        async insertSkill() {
            if (this.actionEdit == "edit") {
                // put skill
                let status = await updateSkill({
                    // ...this.editSkill,
                    id: this.skillID,
                    title: this.skillName,
                    active: this.skillActive,
                });
                // this.editSkill = null;
                if (status.message == "skill name duplicate") {
                    this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
                    this.skillName = "";
                } else if (status.code == 403) {
                    this.dialogAddFail = true; //กรณี error อื่น
                } else {
                    this.dialogEditSuccess = true;
                    this.getSkillList();

                    this.skillID = "";
                    this.skillName = "";
                    this.$refs.form.resetValidation();
                    this.isOpen = false;
                }
            } else {
                let statusAdd = await insertSkill({
                    title: this.skillName,
                });
                if (statusAdd.message == "skill name duplicate") {
                    this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
                    this.skillName = "";
                } else if (statusAdd.code == 403) {
                    this.dialogAddFail = true; //กรณี error อื่น
                } else {
                    this.dialogAddSuccess = true;
                    this.getSkillList();

                    this.skillID = "";
                    this.skillName = "";
                    this.$refs.form.resetValidation();
                    this.isOpen = false;
                }
            }
        },
        editItem(item) {
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
                this.skillName = "";
                this.skillID = "";
                this.actionEdit = "";
            }
            if (item) {
                let index = this.skill.indexOf(item);
                this.editSkill = this.skill[index];
                // let editSkill = this.skill[index];
                this.skillID = this.editSkill.id;
                this.skillName = this.editSkill.title;
                this.skillActive = this.editSkill.active;

                this.actionEdit = "edit";
            }

            this.isOpen = true;
        },
        onSort() {
            if (this.status_toggle == 1) {
                this.params.active = true;

                this.getSkillList();
            } else if (this.status_toggle == 2) {
                this.params.active = false;
                this.getSkillList();
            } else {
                this.params.active = "null";
                this.getSkillList();
            }
        },
        closeDialog() {
            // this.editSkill = null;
            // this.resultSkill = null;
            this.skillID = "";
            this.skillName = "";
            this.$refs.form.resetValidation();
            this.isOpen = false;
        },
        openModalStatus(item) {
            let index = this.skill.indexOf(item);
            this.indexItem = index;
            if (this.skill[index].active == true) {
                this.dialogStatus = true;
                this.updateActiveId = this.skill[index].id;
                this.updateActive = this.skill[index].active;
            } else {
                this.dialogStatusActive = true;
                this.updateActiveId = this.skill[index].id;
                this.updateActive = this.skill[index].active;
            }
        },
        async updateActiveSkill() {
            if (this.updateActive == true) {
                let status = await updateActive({
                    id: this.updateActiveId,
                    active: false,
                });
                this.dialogStatus = false;
                this.dialogSuccess = true;
                this.getSkillList();
                return status;
            } else {
                let status = await updateActive({
                    id: this.updateActiveId,
                    active: true,
                });
                this.dialogStatusActive = false;
                this.dialogSuccess = true;
                this.getSkillList();
                return status;
            }
        },
        cancelStatus() {
            this.dialogStatus = false;
            this.skill[this.indexItem].active = this.updateActive;
        },
        cancelStatusActive() {
            this.dialogStatusActive = false;
            this.skill[this.indexItem].active = this.updateActive;
        },
        deleteItem(item) {
            let index = this.skill.indexOf(item);
            let deleteID = this.skill[index];
            this.skillActive = deleteID.active;
            this.skillID = deleteID.id;
            this.deleteDialog = true;
        },

        async confirmDelete() {
            if (this.skillActive === true) {
                let statusActive = await updateActive({
                    id: this.skillID,
                    active: false,
                });
                let status = await deleteSkill({
                    idskill: this.skillID,
                    istrash: true,
                });
                if (status.code == 403 || statusActive.code == 403) {
                    this.dialogFail = false;
                    this.deleteDialog = false;
                } else {
                    this.deleteDialog = false;
                    this.getSkillList();
                }
            } else {
                let status = await deleteSkill({
                    idskill: this.skillID,
                    istrash: true,
                });
                if (status.code == 403) {
                    this.dialogFail = false;
                    this.deleteDialog = false;
                } else {
                    this.deleteDialog = false;
                    this.getSkillList();
                }
            }
        },
        async openRecycleBin() {
            await this.getSkillListIsTrash();
            this.dialogRecycleBin = true;
        },
        async changePageBin(page) {
            this.paramsBin.page = page;
            await this.getSkillListIsTrash();
        },
        closeDialogRecover() {
            this.dialogRecycleBin = false;
        },
        async closeDialogRecycleBin() {
            this.dialogRecycleBin = false;
            await this.getSkillList();
        },
        async getSkillListIsTrash() {
            let result = await getSkillListBin(this.paramsBin);
            this.skillListBin = [];
            this.pageCountBin = result.maxPage;
            result.data.forEach((skill) => {
                this.skillListBin.push({
                    id: skill._id,
                    image: skill.image,
                    title: skill.title,
                });
            });
        },
        confirmRecover(item) {
            this.skillBinItem = item;
            this.dialogRecover = true;
        },
        async recoverSkill() {
            this.loadingRecover = true;
            let status = await deleteSkill({
                idskill: this.skillBinItem.id,
                istrash: false,
            });
            if (status.code == 403) {
                this.dialogFail = true;
            } else {
                this.deleteDialog = false;
                await this.getSkillListIsTrash();
            }
            this.loadingRecover = false;
            this.dialogRecover = false;
            if (this.skillListBin.length == 0) {
                this.dialogRecycleBin = false;
            }
            this.skillBinItem = null;
            this.page = 1;
            this.pageCount - 1;
            await this.initialize();
        },
    },
};
